// ComplaintExport.jsx
import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, DatePicker, message, Popover, Spin } from "antd";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { BlobFileDownload } from "./BlobDownloadfile";
import { FaAngleDown } from "react-icons/fa";
import "./complaints.scss";

const ComplaintExport = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const { profileData } = useSelector((state) => state.authReducer);

  const handleTodayExport = () => {
    const todayStart = moment().startOf("day");
    const now = moment();
    setFromDate(todayStart);
    setToDate(now);
  };

  const handleFromDateChange = (date) => {
    if (
      date?.isSame(moment(), "day") &&
      (date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second()))
    ) {
      setFromDate(
        date
          .clone()
          .hour(moment().hour())
          .minute(moment().minute())
          .second(moment().second())
      );
    } else {
      setFromDate(date);
    }
    if (date > toDate) {
      setToDate(null);
    }
  };
  const handleToDateChange = (date) => {
    if (date?.isAfter(moment(), "day")) {
      setToDate(moment());
    } else if (date?.isSame(moment(), "day")) {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.isSame(fromDate, "day") &&
        (date?.hour() > moment().hour() ||
          (date?.hour() === moment().hour() &&
            date?.minute() > moment().minute()) ||
          (date?.hour() === moment().hour() &&
            date?.minute() === moment().minute() &&
            date?.second() > moment().second()))
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second())
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else {
        setToDate(date);
      }
    } else {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(date.clone().hour(23).minute(59).second(59));
      } else {
        setToDate(date);
      }
    }
    if (date && date < fromDate) {
      setFromDate(null);
    }
  };

  const disabledFromDate = (current) => {
    return (
      (fromDate && current && current < fromDate?.startOf("day")) ||
      current > moment().endOf("day")
    );
  };

  const disabledToDate = (current) => {
    return (
      (fromDate && current < fromDate.startOf("day")) ||
      current > moment().endOf("day")
    );
  };

   const disabledTime = (currentDate) => {
      const now = moment();
      if (currentDate.isSame(now, 'day')) {
        return {
          disabledHours: () =>
            Array.from({ length: 24 }, (_, i) => i).filter(
              (hour) => hour > now.hour()
            ),
          disabledMinutes: (selectedHour) => {
            if (selectedHour === now.hour()) {
              return Array.from({ length: 60 }, (_, i) => i).filter(
                (minute) => minute > now.minute()
              );
            }
            return [];
          },
          disabledSeconds: () => [],
        };
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => [],
      };
    };

  const handleExport = () => {
    if (!fromDate || !toDate) return;

    const fileUrl = `${
      process.env.REACT_APP_RECON_API_BASE_URL
    }cou-dashboard/complaints/export-data?fromDate=${encodeURIComponent(
      fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ")
    )}&toDate=${encodeURIComponent(
      toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ")
    )}${profileData?.orgId ? `&agentId=${profileData?.orgId}` : ""}`;

    setExporting(true);
    BlobFileDownload(fileUrl, sessionStorage.getItem("biller_access"))
      .then((res) => {
        setExporting(false);
        messageApi.success("File Exported Successfully!");
        setFromDate(null);
        setToDate(null);
      })
      .catch((err) => {
        setExporting(false);
        messageApi.error("Export Failed");
        console.error("Export Error:", err);
      });
  };

  useEffect(() => {
    if (fromDate && toDate) {
      handleExport();
    }
  }, [fromDate, toDate]);

  return (
    <>
      {contextHolder}
      <Popover
        placement="bottom"
        trigger="click"
        content={
          <div
            className="exportBtnDiv"
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <Button 
              className="btn exportBtn"
              onClick={handleTodayExport}
              disabled={exporting}
              style={{ whiteSpace: "nowrap" }}
            >
              {exporting ? (
                "Exporting…"
              ) : (
                <>
                  <DownloadOutlined /> &nbsp; Today
                </>
              )}
            </Button>
            <Popover
              placement="bottom"
              trigger={"click"}
              content={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <DatePicker
                    value={fromDate}
                    style={{ width: "100%", border: "none" }}
                    onChange={handleFromDateChange}
                    disabledDate={disabledFromDate}
                    format="DD-MM-YYYY HH:mm:ss"
                    showTime
                    showNow={false}
                    placeholder="From Date (DD-MM-YYYY HH:mm:ss)"
                    suffixIcon={
                      <CalendarOutlined style={{ color: "#d9d3d3" }} />
                    }
                  />
                  <DatePicker
                    value={toDate}
                    style={{ width: "100%", border: "none" }}
                    onChange={handleToDateChange}
                    disabledDate={disabledToDate}
                    format="DD-MM-YYYY HH:mm:ss"
                    showTime={{
                      format: "HH:mm:ss",
                      disabledTime: disabledTime
                    }}
                    showNow={false}
                    placeholder="To Date (DD-MM-YYYY HH:mm:ss)"
                    suffixIcon={
                      <CalendarOutlined style={{ color: "#d9d3d3" }} />
                    }
                  />
                </div>
              }
            >
              <Button
                style={{
                  width: "180px",
                }}
                // onClick={functionToGetAllTransactionsData}
              >
                Fetch By Date
              </Button>
            </Popover>
            {exporting && (
              <div style={{ textAlign: "center" }}>
                Exporting... <Spin size="small" />
              </div>
            )}
          </div>
        }
      >
        <Button
          className="btn exportBtn"
          style={{
            padding: "10",
            border: "1px solid green",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          Export
          <FaAngleDown />
        </Button>
      </Popover>
    </>
  );
};

export default ComplaintExport;
